<template>
    <div>
        <v-row dense>
            <v-col cols="4" lg="3" sm="12">
                <div class="pa-2">Customer Order Statistics for year:</div>
            </v-col>
            <v-col cols="4" lg="2" sm="12">
                <v-select :items="yearitems" v-model="selyear" dense solo style="font-size: 13px;" @change="getdata"></v-select>
            </v-col>
            <v-col cols="4" lg="7" sm="12"></v-col>
        </v-row>
        <v-row dense id="wrapper">
            <v-col cols="12" lg="3" sm="6" v-for="item in dataitems" :key="item.bpid" class="py-0 mb-7">
                <v-card>
                    <v-card-text class="pa-5">
                        <div class="d-flex align-center">
                            <span class="lstick"></span>
                            <div class="ml-4 mr-1">
                                <h5 class="subtitle-1 grey--text">
                                {{ item.bizpartner }}
                                </h5>
                                <h4>
                                Orders: {{ item.totalorders }}
                                </h4>
                                <h4>
                                Cost: RM {{ formatcurrency(item.totalordercost) }}
                                </h4>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12">
                <v-card flat class="mb-7">
                    <v-card-text class="pa-5">
                        <div class="d-sm-flex align-center">
                            <div>
                                <h3 class="title font-weight-regular">
                                <span class="lstick"></span>Orders
                                </h3>
                                <h6 class="subtitle-2 font-weight-light">Year {{ selyear }}</h6>
                            </div>
                            <!-- <v-spacer></v-spacer>
                            <div class="ml-auto">
                                <div class="d-md-flex align-center"> -->
                            <v-row dense>
                                <v-col cols="2" v-for="item in dataitems" :key="item.bpid">
                                    <v-row dense>
                                        <v-col cols="1">
                                            <span class="overline">
                                                <i :class=" colorstyle[dataitems.indexOf(item)] "></i>
                                            </span>
                                        </v-col>
                                        <v-col cols="11" class="pl-3">
                                            <span class="subtitle-1 d-block font-semibold">Total: {{ item.totalorders }}</span>
                                            <span class="body grey--text">{{ item.bizpartner }}</span>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                                    <!-- <div class="d-flex justify-center align-center px-2 mt-2 mt-md-0" v-for="item in dataitems" :key="item.bpid">
                                        <span class="d-flex align-start">
                                            <span class="overline">
                                                <i :class=" colorstyle[dataitems.indexOf(item)] "></i>
                                            </span>
                                            <div>
                                                <span class="subtitle-1 d-block">Orders: {{ item.totalorders }}</span>
                                                <span class="body grey--text">{{ item.bizpartner }}</span>
                                            </div>
                                        </span>
                                    </div> -->
                                <!-- </div>
                            </div> -->
                        </div>
                        <div v-if="(graphstats_orders.series.length > 0)" class="mt-2" id="graphstats_orders">
                            <vue-apex-charts
                                type="line"
                                height="372px"
                                :options="graphstats_orders.chartOptions"
                                :series="graphstats_orders.series"
                            ></vue-apex-charts>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12">
                <v-card flat class="mb-7">
                    <v-card-text class="pa-5">
                        <div class="d-sm-flex align-center">
                            <div>
                                <h3 class="title font-weight-regular">
                                <span class="lstick"></span>Cost
                                </h3>
                                <h6 class="subtitle-2 font-weight-light">Year {{ selyear }}</h6>
                            </div>
                            <v-row dense>
                                <v-col cols="2" v-for="item in dataitems" :key="item.bpid">
                                    <v-row dense>
                                        <v-col cols="1">
                                            <span class="overline">
                                                <i :class=" colorstyle[dataitems.indexOf(item)] "></i>
                                            </span>
                                        </v-col>
                                        <v-col cols="11" class="pl-3">
                                            <span class="subtitle-1 d-block font-semibold">Total: RM {{ formatcurrency(item.totalordercost) }}</span>
                                            <span class="body grey--text">{{ item.bizpartner }}</span>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                                    <!-- <div class="d-flex justify-center align-center px-2 mt-2 mt-md-0" v-for="item in dataitems" :key="item.bpid">
                                        <span class="d-flex align-start">
                                            <span class="overline">
                                                <i :class=" colorstyle[dataitems.indexOf(item)] "></i>
                                            </span>
                                            <div>
                                                <span class="subtitle-1 d-block">Cost: RM {{ formatcurrency(item.totalordercost) }}</span>
                                                <span class="body grey--text">{{ item.bizpartner }}</span>
                                            </div>
                                        </span>
                                    </div> -->
                                <!-- </div>
                            </div> -->
                        </div>
                        <div v-if="(graphstats_cost.series.length > 0)" class="mt-2" id="graphstats_cost">
                            <vue-apex-charts
                                type="bar"
                                height="372px"
                                :options="graphstats_cost.chartOptions"
                                :series="graphstats_cost.series"
                            ></vue-apex-charts>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-snackbar v-model="sbmsg" timeout="5000" color="green darken-4" dark centered>
            <div v-html="msg"></div>
            <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="sbmsg = false">
                Close
            </v-btn>
            </template>
        </v-snackbar>
        <v-snackbar v-model="sberrmsg" timeout="5000" color="red darken-4" dark centered>
            <div v-html="msg"></div>
            <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="sberrmsg = false">
                Close
            </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts"

export default {
    name: 'TableStatistics',
    props: {

    },
    components: {
        VueApexCharts
    },
    data() {
        return {
            yearitems: [],
            selyear: 0,
            dataitems: [],
            msg: '',
            sbmsg: false,
            sberrmsg: false,
            colorstyle: [
                'deep-purple--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'blue--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'green--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'red--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'cyan--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'magenta--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'orange--text text--lighten-1 fa fa-circle mx-2 mt-3',

                'deep-purple--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'blue--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'green--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'red--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'cyan--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'magenta--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'orange--text text--lighten-1 fa fa-circle mx-2 mt-3',

                'deep-purple--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'blue--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'green--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'red--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'cyan--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'magenta--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'orange--text text--lighten-1 fa fa-circle mx-2 mt-3',

                'deep-purple--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'blue--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'green--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'red--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'cyan--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'magenta--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'orange--text text--lighten-1 fa fa-circle mx-2 mt-3',

                'deep-purple--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'blue--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'green--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'red--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'cyan--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'magenta--text text--lighten-1 fa fa-circle mx-2 mt-3',
                'orange--text text--lighten-1 fa fa-circle mx-2 mt-3',
            ],
            elementvisible: false,
            graphstats_orders: {
                series: [],
                chartOptions: {
                    chart: {
                        height: 370,
                        type: "line",
                        stacked: false,
                        fontFamily: "Montserrat,sans-serif",
                        toolbar: {
                            show: false,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    markers: {
                        size: 3,
                        strokeColors: "transparent",
                    },
                    stroke: {
                        curve: "smooth",
                        width: "2",
                    },
                    fill: {
                        type: "solid",
                        colors: ["#7e57c2", "#42a5f5", "#66bb6a", "#ef5350", "#26c6da"],
                        opacity: 1,
                    },
                    colors: ["#7e57c2", "#42a5f5", "#66bb6a", "#ef5350", "#26c6da"],
                    legend: {
                        show: false,
                    },
                    grid: {
                        show: true,
                        strokeDashArray: 0,
                        borderColor: "rgba(0,0,0,0.1)",
                        yaxis: {
                            show: false,
                        },
                    },
                    xaxis: {
                        type: "Month",
                        categories: [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec",
                        ],
                        labels: {
                            style: {
                                colors: "#a1aab2",
                            },
                        },
                    },
                    yaxis: {
                        labels: {
                            style: {
                                colors: "#a1aab2",
                            },
                        },
                    },
                    tooltip: {
                        theme: "dark",
                        fillColors: ["#7e57c2", "#42a5f5", "#66bb6a", "#ef5350", "#26c6da"],
                    },
                }
            },
            graphstats_cost: {
                series: [],
                chartOptions: {
                    chart: {
                        height: 370,
                        type: "line",
                        stacked: false,
                        fontFamily: "Montserrat,sans-serif",
                        toolbar: {
                            show: false,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    markers: {
                        size: 3,
                        strokeColors: "transparent",
                    },
                    stroke: {
                        curve: "smooth",
                        width: "2",
                    },
                    fill: {
                        type: "solid",
                        colors: ["#7e57c2", "#42a5f5", "#66bb6a", "#ef5350", "#26c6da"],
                        opacity: 1,
                    },
                    colors: ["#7e57c2", "#42a5f5", "#66bb6a", "#ef5350", "#26c6da"],
                    legend: {
                        show: false,
                    },
                    grid: {
                        show: true,
                        strokeDashArray: 0,
                        borderColor: "rgba(0,0,0,0.1)",
                        yaxis: {
                            show: false,
                        },
                    },
                    xaxis: {
                        type: "Month",
                        categories: [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec",
                        ],
                        labels: {
                            style: {
                                colors: "#a1aab2",
                            },
                        },
                    },
                    yaxis: {
                        labels: {
                            style: {
                                colors: "#a1aab2",
                            },
                        },
                    },
                    tooltip: {
                        theme: "dark",
                        fillColors: ["#7e57c2", "#42a5f5", "#66bb6a", "#ef5350", "#26c6da"],
                    },
                }
            }
        }
    },
    watch: {},
    computed: {},
    mounted: function () {
        this.initialize()
        setTimeout(() => (this.elementvisible = true), 10)
    },
    methods: {
        initialize() {
            var curyear = new Date().getFullYear()
            this.selyear = curyear
            this.getyears()
            this.getdata()
        },

        getyears() {
            var min = new Date().getFullYear() - 10
            var max = new Date().getFullYear()
            for (var i = min; i <= max; i++) {
                this.yearitems.push(i)
            }
        },

        getdata() {
            var targetPath = '/admin/dashboard/statistic/' + this.selyear.toString()
            axios.get(targetPath)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.dataitems = rtn.data
                        this.buildchart_orders()
                        this.buildchart_cost()
                    } else {
                        this.dataitems = []
                        this.graphstats_orders.series = []
                        this.graphstats_cost.series = []
                        this.msg = rtn.error
                        this.sberrmsg = true
                    }
                }
            })
        },

        formatcurrency(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        buildchart_orders() {
            this.graphstats_orders.series = []

            for (var i=0;i<this.dataitems.length;i++) {
                var itm = this.dataitems[i]
                var newitm = {
                    name: itm.bizpartner,
                    data: [itm.tot_1, itm.tot_2, itm.tot_3, itm.tot_4, itm.tot_5, itm.tot_6, itm.tot_7, itm.tot_8, itm.tot_9, itm.tot_10, itm.tot_11, itm.tot_12]
                }
                this.graphstats_orders.series.push(newitm);
            }
        },

        buildchart_cost() {
            this.graphstats_cost.series = []

            for (var i=0;i<this.dataitems.length;i++) {
                var itm = this.dataitems[i]
                var newitm = {
                    name: itm.bizpartner,
                    data: [itm.cost_1, itm.cost_2, itm.cost_3, itm.cost_4, itm.cost_5, itm.cost_6, itm.cost_7, itm.cost_8, itm.cost_9, itm.cost_10, itm.cost_11, itm.cost_12]
                }
                this.graphstats_cost.series.push(newitm);
            }
        }
    }
}
</script>

